import React from 'react'

const OnlineExperienceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.387 20.187a.64.64 0 0 1 .64-.64h8.088a.64.64 0 0 1 0 1.28h-8.088a.64.64 0 0 1-.64-.64Z"
        fill="url(#a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.049 23.421a.64.64 0 0 1 .64-.64h1.293a.64.64 0 0 1 0 1.28H24.69a.64.64 0 0 1-.64-.64Z"
        fill="url(#b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.27 23.406a.64.64 0 0 1 .64-.64H9.2a.64.64 0 0 1 0 1.28H7.91a.64.64 0 0 1-.64-.64Z"
        fill="url(#c)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.105 14.686a1.36 1.36 0 0 0-1.36 1.36v7.959a1.36 1.36 0 0 0 1.36 1.36h2.46a1.36 1.36 0 0 0 1.36-1.36v-9.319h-3.82Zm-1.867-.506a2.64 2.64 0 0 1 1.867-.774h5.1v10.599a2.64 2.64 0 0 1-2.64 2.64h-2.46a2.64 2.64 0 0 1-2.64-2.64v-7.959c0-.7.278-1.371.773-1.866Z"
        fill="url(#d)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.382 10.64A1.36 1.36 0 0 0 4.022 12v12.05a1.36 1.36 0 0 0 1.36 1.36h6.554a1.36 1.36 0 0 0 1.36-1.36V10.64H5.382Zm-1.867-.507a2.64 2.64 0 0 1 1.867-.774h9.194v14.69a2.64 2.64 0 0 1-2.64 2.64H5.382a2.64 2.64 0 0 1-2.64-2.64V12c0-.7.278-1.371.773-1.866Z"
        fill="url(#e)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.295 23.406a.64.64 0 0 1 .64-.64h5.247a.64.64 0 0 1 0 1.28h-5.247a.64.64 0 0 1-.64-.64Z"
        fill="url(#f)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.674 19.89a.64.64 0 0 1 .641.64l.005 2.553a.64.64 0 1 1-1.28.002l-.005-2.553a.64.64 0 0 1 .639-.641Z"
        fill="url(#g)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.045 5.049A3.473 3.473 0 0 1 7.5 4.03h20.498v10.007a.64.64 0 1 1-1.28 0V5.311H7.501a2.193 2.193 0 0 0-2.194 2.194v2.491a.64.64 0 1 1-1.28 0V7.505a3.47 3.47 0 0 1 1.018-2.456Z"
        fill="url(#h)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.675 18.64a.615.615 0 1 0 0-1.23.615.615 0 0 0 0 1.23Zm-.665-.616a.665.665 0 1 1 1.33 0 .665.665 0 0 1-1.33 0Z"
        fill="url(#i)"
      />
      <path
        d="M16.704 18.021a.028.028 0 1 1-.057 0 .028.028 0 0 1 .057 0Z"
        fill="url(#j)"
        stroke="url(#k)"
        strokeWidth={1.33}
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-13.69197 -1.87898 1.72201 -12.5482 25.107 21.162)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-153.452 16.512 8.982) scale(4.20426 11.4365)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-153.437 8.12 10.953) scale(4.20208 11.435)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="d"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-11.31223 -19.434 57.48644 -33.46194 31.148 30.113)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="e"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-124.208 17.04 10.97) scale(30.7626 97.3106)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="f"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-168.856 11.92 11.144) scale(9.72216 12.5434)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="g"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-108.456 17.73 6.009) scale(5.93251 12.1204)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="h"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-35.03508 -15.6294 39.56415 -88.68752 34.016 17.468)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="i"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-134.873 12.792 5.847) scale(2.75509 9.37224)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="j"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-134.873 12.822 5.858) scale(2.87248 9.77157)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="k"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-134.873 12.822 5.858) scale(2.87248 9.77157)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default OnlineExperienceIcon